import type { SVGProps } from 'react';

export function TransactionInIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <circle cx="24" cy="24" r="24" fill="url(#paint0_linear_7448_16448)"/>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7193 18C21.3224 18 21.0004 18.322 21.0004 18.72C21.0004 19.118 21.3224 19.44 21.7193 19.44H27.5421L18.2115 28.7712C17.9295 29.0522 17.9295 29.5082 18.2115 29.7892C18.4925 30.0703 18.9475 30.0703 19.2294 29.7892L28.5601 20.4581V26.2802C28.5601 26.6782 28.882 27.0002 29.28 27.0002C29.677 27.0002 30 26.6782 30 26.2802V18.72C30 18.322 29.677 18 29.28 18H21.7193Z"
        fill="#1C2633"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7448_16448"
          x1="25.463"
          y1="58.2585"
          x2="58.9708"
          y2="23.5245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F9F9"/>
          <stop offset="1" stopColor="#E7E7E7"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
